import React from 'react';

import WinnerContent from './WinnerContent';

const WinnerLayer = (props) => {
	const close = () => {
		if(props.backButton) props.backButton();
	};

	return (
		<aside class="won_prize">
			<div class="winners_bg" onClick={close}>
				<div
					class="bg_color"
					style={{ background:props?.layout_props?.layer?.overlay_color ?? 'rgba(0, 0, 0, 0.9)' }}
				/>
			</div>

			<div class="winner_layer">
				<WinnerContent
					{...props}
				/>
			</div>
		</aside>
	);
};

export default WinnerLayer;